const API_URL = process.env.REACT_APP_BACKEND_URL;

function getVisitorId() {
  let id = localStorage.getItem('ch_vid');
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem('ch_vid', id);
  }
  return id;
}

function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source');
  if (source) {
    sessionStorage.setItem('ch_utm', JSON.stringify({
      utm_source: source,
      utm_medium: params.get('utm_medium') || null,
      utm_campaign: params.get('utm_campaign') || null,
    }));
  }
  return JSON.parse(sessionStorage.getItem('ch_utm') || 'null');
}

const getDevice = () => {
  const ua = navigator.userAgent;
  if (/iPad|Tablet/i.test(ua)) return 'tablet';
  if (/Mobi|Android|iPhone/i.test(ua)) return 'mobile';
  return 'desktop';
};

let firstView = true;

// Append UTM parameters to an outbound share link so inbound visits are attributed
export function withUtm(url, { source = 'share', medium = 'link', campaign = null, content = null } = {}) {
  try {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('utm_source', source);
    u.searchParams.set('utm_medium', medium);
    if (campaign) u.searchParams.set('utm_campaign', campaign);
    if (content) u.searchParams.set('utm_content', content);
    return u.toString();
  } catch {
    return url;
  }
}

const TABOOLA_ID = 2088249;

function pushTaboola(name) {
  try {
    window._tfa = window._tfa || [];
    window._tfa.push({ notify: 'event', name, id: TABOOLA_ID });
  } catch {
    // never break the app for analytics
  }
}

export function trackConversion(eventName) {
  try {
    if (!eventName.startsWith('pwa_')) pushTaboola(eventName);
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        path: window.location.pathname,
        event: eventName,
        device: getDevice(),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // never break the app for analytics
  }
}

export function trackPageview(path) {
  try {
    const utm = captureUtm();
    const payload = {
      visitor_id: getVisitorId(),
      path,
      referrer: firstView ? (document.referrer || null) : null,
      utm_source: utm?.utm_source || null,
      utm_medium: utm?.utm_medium || null,
      utm_campaign: utm?.utm_campaign || null,
      device: getDevice(),
    };
    if (!firstView) pushTaboola('page_view');
    firstView = false;
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // never break the app for analytics
  }
}

const _videoSent = new Set();
export function trackVideoEvent(videoId, event) {
  try {
    const key = `${videoId}:${event}`;
    if (_videoSent.has(key)) return;
    _videoSent.add(key);
    fetch(`${API_URL}/api/analytics/video-event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ video_id: videoId, event }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // never break the app for analytics
  }
}
